import * as React from "react";
function TransportPublicTrain() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636566",
    fillRule: "nonzero",
    d: "M0,-23.981L75.937,-11.167C101.001,-6.664 109.397,-4.638 113.456,-2.701L96.081,-0.321C93.775,0 87.538,-1.308 83.593,-2.738L-3.02,-22.693L0,-23.981Z",
    opacity: 0.47,
    transform: "translate(6.4 93.925)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M0,-5.232C-0.64,-1.291 2.412,1.883 4.359,2.242C6.305,2.6 8.686,-2.906 5.631,-5.369C2.577,-7.832 0,-5.232 0,-5.232",
    transform: "translate(39.516 74.062)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M32.168,-45.483C37.141,-46.817 40.681,-44.169 40.689,-40.335C40.696,-36.501 32.168,26.035 32.168,26.035C32.168,26.035 21.178,19.588 20.924,13.751C20.67,7.913 32.168,-45.483 32.168,-45.483",
    transform: "scale(-1 1) rotate(71.986 -59.398 -17.91)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#767777",
    fillRule: "nonzero",
    d: "M0,-12.672C0.719,-12.585 3.068,-11.224 3.982,-8.849C4.866,-6.553 5.544,-4.197 6.317,-2.878C7.674,-0.503 19.052,0 19.052,0C19.052,0 14.033,-10.573 13.441,-11.2C12.551,-12.55 0,-12.672 0,-12.672",
    transform: "translate(52.633 79.893)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "nonzero",
    d: "M0,-61.462C2.309,-62.076 10.642,-62.217 23.054,-61.649C34.928,-61.106 39.515,-58.503 41.831,-54.339C44.127,-50.212 48.763,-41.349 50.391,-29.568C52.01,-17.859 51.911,-12.07 52.314,-9.058C52.717,-6.05 52.815,-2.88 51.505,-2.327C50.188,-1.772 20.91,0.755 18.178,0.009C15.419,-0.743 13.914,-1.01 11.815,-3.427C9.701,-5.861 5.782,-14.194 5.064,-15.172C4.344,-16.153 2.688,-17.671 2.095,-17.776C-1.701,-18.449 -8.612,-18.567 -8.948,-19.015C-8.948,-19.578 -10.605,-44.72 -9.82,-52.071C-11.212,-51.578 -62.296,-43.36 -62.296,-43.36C-62.296,-43.36 -62.612,-45.515 -59.935,-47.051C-57.28,-48.575 0,-61.462 0,-61.462",
    transform: "translate(62.565 88.354)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#767777",
    fillRule: "nonzero",
    d: "M0,-19.029C-2.322,-18.387 -3.879,-17.818 -4.009,-16.887C-4.139,-15.957 -3.619,2.222 -3.619,2.222L52.665,8.312C52.665,8.312 50.793,-25.191 52.989,-27.341C52.015,-27.175 0,-19.029 0,-19.029",
    transform: "translate(4.174 62.267)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0,-22.943C-2.14,-22.56 -3.755,-22.896 -2.812,-19.847C-1.871,-16.808 2.123,-4.749 2.916,-3.371C3.705,-1.998 3.968,-0.759 7.621,-0.584C11.226,-0.412 23.724,0 26.881,-0.904C30,-1.797 30.833,-2.135 30.952,-4.129C31.071,-6.122 27.844,-18.603 27.122,-20.176C26.398,-21.753 26.277,-21.996 24.091,-21.997C21.886,-21.998 0,-22.943 0,-22.943",
    transform: "translate(77.86 59.102)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474646",
    fillRule: "nonzero",
    d: "M0,16.985C-0.598,13.122 -3.076,3.677 -3.699,2.322C-4.423,0.745 -4.544,0.502 -6.73,0.501C-8.05,0.5 -16.426,0.161 -22.935,-0.111C-21.432,4.514 -18.62,12.855 -17.968,13.987C-17.179,15.36 -16.916,16.599 -13.263,16.774C-10.923,16.886 -4.846,17.096 0,16.985",
    transform: "translate(98.743 41.744)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#767777",
    fillRule: "nonzero",
    d: "M0,-15.618C0,-15.116 2.134,-8.944 2.942,-6.564C3.747,-4.19 4.321,-3.351 7.249,-1.989C10.146,-0.641 11.416,0 11.416,-0.861C11.416,-1.722 9.453,-8.256 8.268,-10.617C7.079,-12.987 5.74,-14.029 4.405,-14.427C3.065,-14.828 0,-15.618 0,-15.618",
    transform: "translate(72.375 69.808)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#767777",
    fillRule: "nonzero",
    d: "M0,-15.611C0.129,-15.226 0.978,-10.014 1.343,-7.812C1.727,-5.496 1.75,-4.607 0.939,-2.817C0.082,-0.925 -0.296,0 -0.563,-0.945C-0.826,-1.874 -1.827,-8.65 -1.954,-10.903C-2.074,-13.038 -1.799,-13.996 -1.373,-14.409C-0.954,-14.814 0,-15.611 0,-15.611",
    transform: "translate(112.246 70.515)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0,-10.632C0.409,-9.473 2.579,-3.323 3.523,-1.289C4.464,0.737 4.732,1.241 9.383,1.218C13.956,1.196 20.228,0.368 21.238,-0.409C22.244,-1.184 22.871,-2.317 23.622,-5.307C24.37,-8.288 24.619,-11.873 24.619,-11.873L0,-10.632Z",
    transform: "translate(86.706 82.55)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0,-19.697C0,-18.605 -0.058,-5.589 0.398,-5.172C0.853,-4.756 5.722,-5.135 7.801,-4.564C9.866,-3.997 17.262,0.739 17.262,0.739C17.262,0.739 13.806,-11.808 12.644,-14.244C11.478,-16.69 11.414,-19.384 8.476,-19.908C5.508,-20.436 0,-19.697 0,-19.697",
    transform: "translate(56.03 62.574)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M26.161,-24.538C26.773,-24.423 34.075,-22.784 34.075,-22.784L26.161,22.79L11.926,19.138L26.161,-24.538Z",
    transform: "scale(-1 1) rotate(79.342 -32.976 -5.47)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0,-32.396C-0.425,-31.479 -1.069,-29.964 -1.063,-26.344C-1.058,-23.613 -0.144,-0.087 -0.144,-0.087L6.745,0.682C6.745,0.682 5.98,-15.862 5.88,-18.554C5.43,-30.625 6.334,-33.078 6.334,-33.078L0,-32.396Z",
    transform: "translate(46.913 69.553)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#767777",
    fillRule: "nonzero",
    d: "M0,-15.677C0,-15.677 -0.012,-12.572 0.248,-11.121C0.507,-9.671 1.387,-9.096 2.42,-8.692C3.449,-8.289 6.575,-7.975 6.575,-7.975C6.575,-7.975 4.504,-8.702 4.526,-11.175C4.542,-12.953 4.743,-12.989 5.105,-13.191C5.875,-13.136 10.865,-12.786 11.523,-12.598C10.691,-7.778 13.601,-7.409 13.85,-7.107C14.098,-6.806 43.589,0 43.589,0C43.589,0 40.668,-0.776 40.452,-3.8C39.744,-7.01 41.092,-7.028 41.092,-7.028C41.092,-7.028 56.927,-5.708 58.565,-5.08C60.193,-4.456 67.074,-3.146 67.074,-3.146C67.074,-3.146 64.47,-10.65 62.755,-10.728C61.03,-10.806 0,-15.677 0,-15.677",
    transform: "translate(.555 76.328)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#767777",
    fillRule: "nonzero",
    d: "M0,-12.602C-0.923,-11.502 -1.386,-11.641 -1.386,-8.501C-1.386,-5.361 -1.232,0.041 -1.232,0.041L0.921,0.192C0.921,0.192 0.307,-11.089 1.074,-11.942C1.839,-12.794 0,-12.602 0,-12.602",
    transform: "translate(11.168 58.777)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#767777",
    fillRule: "nonzero",
    d: "M0,-19.45C-1.367,-17.763 -2.054,-17.983 -2.054,-13.136C-2.054,-8.289 -1.825,0.051 -1.825,0.051L1.361,0.273C1.361,0.273 0.454,-17.114 1.588,-18.421C2.717,-19.723 0,-19.45 0,-19.45",
    transform: "translate(26.65 60.521)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#767777",
    fillRule: "nonzero",
    d: "M-2.193,-2.444C-4.294,-2.606 -6.001,-1.758 -6.009,-0.546C-6.018,0.672 -4.311,1.799 -2.193,1.966C-0.073,2.133 1.641,1.274 1.633,0.051C1.624,-1.166 -0.09,-2.281 -2.193,-2.444",
    transform: "scale(-1 1) rotate(-83.934 -26.635 62.728)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#767777",
    fillRule: "nonzero",
    d: "M-2.142,-2.392C-4.218,-2.544 -5.905,-1.71 -5.913,-0.525C-5.921,0.665 -4.234,1.76 -2.142,1.916C-0.047,2.072 1.646,1.227 1.638,0.032C1.63,-1.157 -0.064,-2.241 -2.142,-2.392",
    transform: "scale(-1 1) rotate(-83.804 -29.457 66.73)"
  }));
}
export default TransportPublicTrain;